<template>
  <el-form-item :label="i18nt('designer.setting.filterable')">
    <el-switch v-model="optionModel.filterable" />
  </el-form-item>
</template>

<script>
import i18n from '@/utils/i18n'

/* eslint-disable */
export default {
  name: 'FilterableEditor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped>

</style>
